import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Login from "./Login";
import Signup from "./Signup";
import { megaMenuImages } from "../store/Dropdowndata";
import SearchFields from "./SearchFields";
import CitySearch from "./CitySearch";
import useDropdownStore from "../store/useDropdownStore";
import useFilterStore from "../store/useFilterStore";
import { useNavigate } from "react-router-dom";
import { toTitleCase, toUppercase } from "../utils/stringExtensions";
import ContentLoader from "react-content-loader";

// API base path from environment variable, defaults to empty string for relative paths
const API_BASE_PATH = process.env.REACT_APP_RESOAPI_BASE_URL || "";

const Header = () => {
  const [showLogin, setShowLogin] = useState(false);
  const [showSignup, setShowSignup] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(!!window.isUserLoggedIn);
  const [showAccountMenu, setShowAccountMenu] = useState(false);
  const location = useLocation();
  
  // Determine active menu items based on current route
  const isNeighborhoodPage = location.pathname.toLowerCase().includes('neighborhood');
  const isRentalPage = location.pathname.toLowerCase().includes('rental');
  const isBuilderPage = location.pathname.toLowerCase().includes('builder') || location.pathname.toLowerCase().includes('build');
  
  const [filterOpen, setFilterOpen] = useState(false);
  const [moreFilters, setMoreFilters] = useState(false);
  const [activeFilterRow, setActiveFilterRow] = useState(null);
  const [activeFilterItem, setActiveFilterItem] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [openMenuIndex, setOpenMenuIndex] = useState(0);
  const [search, setSearch] = useState("");
  const [activeMega, setActiveMega] = useState(null);
  const [searchCity, setSearchCity] = useState(() => localStorage.getItem("searchCity") || "");
  const [city1Images, setCity1Images] = useState([
    require("../assets/image/header/mega-menu-img-1.png"),
    require("../assets/image/header/mega-menu-img-2.png"),
    require("../assets/image/header/mega-menu-img-3.png"),
    require("../assets/image/header/mega-menu-img-4.png")
  ]);
  const [city2Images, setCity2Images] = useState([
    require("../assets/image/header/mega-menu-img-5.png"),
    require("../assets/image/header/mega-menu-img-6.png"),
    require("../assets/image/header/mega-menu-img-7.png"),
    require("../assets/image/header/mega-menu-img-8.png")
  ]);
  // const [city1Name, setCity1Name] = useState("Newnan");
  // const [city2Name, setCity2Name] = useState("LaGrange");
  const [city1Name, setCity1Name] = useState("");
  const [city2Name, setCity2Name] = useState("");
  const [loadingCityImages, setLoadingCityImages] = useState(false);

  //Search fields
   const { metadata, fetchMetadata } = useDropdownStore();
    const { filterData, storeFilterData } = useFilterStore();
    const [autocompletevalue, setautocompleteValue] = useState("");
    const [selectedMinprice, setSelectedMinprice] = useState(null);
    const [selectedMaxprice, setSelectedMaxprice] = useState(null);
    const [selectedBeds, setSelectedBeds] = useState(null);
    const [selectedBaths, setSelectedBaths] = useState(null);
    const [selectedLotSize, setSelectedLotSize] = useState(null);
    const [selectedPropertyStatus, setSelectedPropertyStatus] = useState(null);
    const [selectedPropertyType, setSelectedPropertyType] = useState(null);
    const [selectedforeclosure, setSelectedforeclosure] = useState(null);
    const [selectedshortsale, setSelectedshortsale] = useState(null);
    const [selectedpoolpreference, setSelectedpoolpreference] = useState(null);
    const [propertyminage, setpropertyminage] = useState("");
    const [propertymaxage, setpropertymaxage] = useState("");
    const [livingareamin, setlivingareamin] = useState("");
    const [livingareamax, setlivingareamax] = useState("");
    const [separatediningroom, setseparatediningroom] = useState(false);
    const [eatinkitchen, seteatinkitchen] = useState(false);
    const [counterislandseating, setcounterislandseating] = useState(false);
    const [breakfastnook, setbreakfastnook] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [selectedsorting, setselectedsorting] = useState("7");
    const navigate = useNavigate();
    //Search fields


  // Ensure Bootstrap Modal JS is available
  useEffect(() => {
    if (showLogin || showSignup) {
      // Dynamically import Bootstrap JS if not already loaded
      if (!window.bootstrap) {
        import("bootstrap/dist/js/bootstrap.bundle.min.js").then((mod) => {
          window.bootstrap = mod;
        });
      }
    }
  }, [showLogin, showSignup]);

  // Restore login state from localStorage or cookie on mount
  useEffect(() => {
    // Try to restore user info from localStorage
    const userInfoStr = localStorage.getItem("userInfo");
    if (userInfoStr) {
      try {
        window.userInfo = JSON.parse(userInfoStr);
        window.isUserLoggedIn = true;
      } catch {
        window.userInfo = undefined;
        window.isUserLoggedIn = false;
      }
    } else {
      window.userInfo = undefined;
      window.isUserLoggedIn = false;
    }
    setIsLoggedIn(!!window.isUserLoggedIn);
  }, []);

  // Check login status on mount and when modals close
  useEffect(() => {
    const checkLogin = () => setIsLoggedIn(!!window.isUserLoggedIn);
    checkLogin();
    window.addEventListener("loginStatusChanged", checkLogin);
    return () => window.removeEventListener("loginStatusChanged", checkLogin);
  }, []);

  // Hide account menu on document click
  useEffect(() => {
    if (!showAccountMenu) return;
    const handleClick = (e) => {
      if (
        !e.target.closest(".account-menu") &&
        !e.target.closest(".user-avatar")
      ) {
        setShowAccountMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [showAccountMenu]);

  // Scroll to top is now handled by ScrollToTop component in App.js
  // Removed duplicate scroll logic to avoid conflicts

  // Listen for search city changes from Search component and localStorage
  useEffect(() => {
    const handleCityChange = (e) => {
      if (e.detail && e.detail.city !== undefined) {
        const cityValue = e.detail.city;
        setSearchCity(cityValue);
        if (cityValue) {
          localStorage.setItem("searchCity", cityValue);
        } else {
          localStorage.removeItem("searchCity");
        }
      }
    };

    // Listen for custom event
    window.addEventListener("searchCityChanged", handleCityChange);

    // Listen for localStorage changes (for cross-tab communication)
    const handleStorageChange = (e) => {
      if (e.key === "searchCity") {
        const newCity = e.newValue || "";
        setSearchCity(newCity);
      }
    };

    // Listen for storage events (from other tabs/windows)
    window.addEventListener("storage", handleStorageChange);

    // Also check localStorage periodically (for same-tab updates from other components)
    // Use a ref to track the last known value to avoid unnecessary updates
    let lastKnownCity = localStorage.getItem("searchCity") || "";
    const checkLocalStorage = () => {
      const storedCity = localStorage.getItem("searchCity") || "";
      if (storedCity !== lastKnownCity) {
        lastKnownCity = storedCity;
        setSearchCity(storedCity);
      }
    };

    // Check immediately and then periodically
    checkLocalStorage();
    const intervalId = setInterval(checkLocalStorage, 500);

    return () => {
      window.removeEventListener("searchCityChanged", handleCityChange);
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(intervalId);
    };
  }, []); // Empty dependency array - only set up listeners once

  // Fetch city mapping and images when city changes
  useEffect(() => {
    const currentCity = searchCity || localStorage.getItem("searchCity") || "newnan";
    if (!currentCity) return;

    const fetchCityData = async () => {
      setLoadingCityImages(true);
      try {
        // Fetch city mapping
        const cityParam = encodeURIComponent(currentCity.toLowerCase());
        const mappingResponse = await fetch(`${API_BASE_PATH}/Api/website/GetCityMapping?primarycity=${cityParam}`);
        
        if (mappingResponse.ok) {
          const mappingData = await mappingResponse.json();
          console.log("City Mapping API Response:", mappingData);
          console.log("Response type:", typeof mappingData, Array.isArray(mappingData));
          
          // Handle array response (if API returns array)
          let data = mappingData;
          if (Array.isArray(mappingData) && mappingData.length > 0) {
            data = mappingData[0];
            console.log("Using first element of array:", data);
          }
          
          // Handle different possible response structures
          const city1 = data?.city1 || data?.City1 || data?.city_1 || data?.City_1 || "";
          const city2 = data?.city2 || data?.City2 || data?.city_2 || data?.City_2 || "";
          
          console.log("Extracted city1:", city1, "city2:", city2);
          
          if (city1 && city2) {
            const formattedCity1 = toTitleCase(city1);
            const formattedCity2 = toTitleCase(city2);
            console.log("Setting city names:", formattedCity1, formattedCity2);
            setCity1Name(formattedCity1);
            setCity2Name(formattedCity2);

            // Helper function to get random 4 images from array
            const getRandomImages = (images, count = 4) => {
              const shuffled = [...images].sort(() => 0.5 - Math.random());
              return shuffled.slice(0, count);
            };

            // Fetch images for city1
            const city1Param = encodeURIComponent(city1.toLowerCase());
            const city1Response = await fetch(`${API_BASE_PATH}/Api/website/GetCityImages?city=${city1Param}`);
            if (city1Response.ok) {
              const city1ImagesData = await city1Response.json();
              if (Array.isArray(city1ImagesData) && city1ImagesData.length > 0) {
                const randomImages = getRandomImages(city1ImagesData, 4);
                setCity1Images(randomImages);
              }
            }

            // Fetch images for city2
            const city2Param = encodeURIComponent(city2.toLowerCase());
            const city2Response = await fetch(`${API_BASE_PATH}/Api/website/GetCityImages?city=${city2Param}`);
            if (city2Response.ok) {
              const city2ImagesData = await city2Response.json();
              if (Array.isArray(city2ImagesData) && city2ImagesData.length > 0) {
                const randomImages = getRandomImages(city2ImagesData, 4);
                setCity2Images(randomImages);
              }
            }
          } else {
            console.warn("City names not found in API response:", mappingData);
          }
        } else {
          console.warn("City mapping API response not ok:", mappingResponse.status);
        }
      } catch (error) {
        console.error("Error fetching city data:", error);
      } finally {
        setLoadingCityImages(false);
      }
    };

    fetchCityData();
  }, [searchCity]);

  
    useEffect(() => {
      if (!metadata) {
        fetchMetadata(); // Fetch only once
      }
    }, [metadata]);

  const openLogin = () => {
    setShowSignup(false);
    // Always set to true - the Login component will handle showing the modal
    // even if it's already true (using getOrCreateInstance)
    setShowLogin(true);
    // Also dispatch event as a fallback to ensure modal opens on rapid taps
    // This ensures the modal opens even if React state updates are batched
    window.dispatchEvent(new Event('openLoginModal'));
  };
  const openSignup = () => {
    setShowLogin(false);
    // Always set to true - the Signup component will handle showing the modal
    // even if it's already true (using getOrCreateInstance)
    setShowSignup(true);
    // Also dispatch event as a fallback to ensure modal opens on rapid taps
    // This ensures the modal opens even if React state updates are batched
    window.dispatchEvent(new Event('openRegisterModal'));
  };
  const closeModals = () => {
    setShowLogin(false);
    setShowSignup(false);
  };
  const handleAvatarClick = () => {
    setShowAccountMenu((prev) => !prev);
  };
  const handleLogout = () => {
    window.isUserLoggedIn = false;
    window.userInfo = undefined;
    localStorage.removeItem("userInfo");
    document.cookie =
      "userInfo=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
    window.dispatchEvent(new Event("loginStatusChanged"));
    setShowAccountMenu(false);

    // Always navigate to home on logout
    navigate("/");
  };

  const navLinks = [
    { label: "Search Listings", to: "/search" },
    { label: "Build Your Happy", to: "/construction/2" },
    { label: "Lake Homes", to: "/lakehomes" },
    { label: "Neighborhoods", to: "/neighborhoods" },
    { label: "Rentals", to: "/rentals" },
    { label: "Contact", to: "/contact" },
  ];

    const populateFromFilterData = () => {
    if (filterData && Object.keys(filterData).length > 0) {
      setautocompleteValue(filterData.searchtext || "");
      setSelectedMinprice(filterData.minprice || null);
      setSelectedMaxprice(filterData.maxprice || null);
      setSelectedBeds(filterData.beds || null);
      setSelectedBaths(filterData.baths || null);
      setSelectedLotSize(filterData.lotSize || null);
      setSelectedPropertyStatus(filterData.propertyStatus || null);
      setSelectedPropertyType(filterData.propertyType || null);
      setSelectedforeclosure(filterData.foreclosure || null);
      setSelectedshortsale(filterData.shortsale || null);
      setSelectedpoolpreference(filterData.poolpreference || null);
      setpropertyminage(filterData.propertyminage || "");
      setpropertymaxage(filterData.propertymaxage || "");
      setlivingareamin(filterData.livingareamin || "");
      setlivingareamax(filterData.livingareamax || "");
      setseparatediningroom(!!filterData.separatediningroom);
      seteatinkitchen(!!filterData.eatinkitchen);
      setcounterislandseating(!!filterData.counterislandseating);
      setbreakfastnook(!!filterData.breakfastnook);
      setselectedsorting(filterData.sortby || "7"); // Default to "7" if not set
    }
  };
  // Function called from SearchFields component
  const handleSearchFieldsSubmit = (searchFieldsData) => {
    // Update local state with values from SearchFields
    setautocompleteValue(searchFieldsData.searchtext);
    setSelectedMinprice(searchFieldsData.minprice);
    setSelectedMaxprice(searchFieldsData.maxprice);
    setSelectedBeds(searchFieldsData.beds);
    setSelectedBaths(searchFieldsData.baths);

    // Build full form data combining SearchFields data with more options
    const formData = {
      searchtext: searchFieldsData.searchtext,
      minprice: searchFieldsData.minprice,
      maxprice: searchFieldsData.maxprice,
      beds: searchFieldsData.beds,
      baths: searchFieldsData.baths,
      propertyType: selectedPropertyType,
      propertyStatus: selectedPropertyStatus,
      foreclosure: selectedforeclosure,
      shortsale: selectedshortsale,
      poolpreference: selectedpoolpreference,
      propertyminage: propertyminage,
      propertymaxage: propertymaxage,
      livingareamin: livingareamin,
      livingareamax: livingareamax,
      lotSize: selectedLotSize,
      separatediningroom: separatediningroom,
      eatinkitchen: eatinkitchen,
      counterislandseating: counterislandseating,
      breakfastnook: breakfastnook,
      PageNumber: 1,
      sortby: selectedsorting,
    };
    storeFilterData(formData);

    // Navigate to /search or /search/:city so Search reflects the selected city and criteria
    const cityLabel = (searchFieldsData.searchtext && searchFieldsData.searchtext.label) || (typeof searchFieldsData.searchtext === "string" && searchFieldsData.searchtext.trim()) || "";
    if (cityLabel) {
      navigate(`/search/${cityLabel.toLowerCase().trim()}`);
    } else {
      navigate("/search");
    }
  };

  // Function to serialize and submit the search form (used by More Options Apply button)
  const handleSearchSubmit = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    const formData = {
      searchtext: autocompletevalue,
      minprice: selectedMinprice,
      maxprice: selectedMaxprice,
      beds: selectedBeds,
      baths: selectedBaths,
      propertyType: selectedPropertyType,
      propertyStatus: selectedPropertyStatus,
      foreclosure: selectedforeclosure,
      shortsale: selectedshortsale,
      poolpreference: selectedpoolpreference,
      propertyminage: propertyminage,
      propertymaxage: propertymaxage,
      livingareamin: livingareamin,
      livingareamax: livingareamax,
      lotSize: selectedLotSize,
      separatediningroom: separatediningroom,
      eatinkitchen: eatinkitchen,
      counterislandseating: counterislandseating,
      breakfastnook: breakfastnook,
      PageNumber: 1,
      sortby: selectedsorting,
    };
    storeFilterData(formData);
    // Navigate to /search or /search/:city so Search reflects the selected city and criteria
    const cityLabel = (formData.searchtext && formData.searchtext.label) || (typeof formData.searchtext === "string" && formData.searchtext.trim()) || "";
    if (cityLabel) {
      navigate(`/search/${cityLabel.toLowerCase().trim()}`);
    } else {
      navigate("/search");
    }
  };

  return (
    <>
      <header className="main-header">
        <nav className="navbar navbar-expand-lg custom-navbar">
          <div className="container">
            <Link to="/" className="navbar-br/and d-flex align-items-center">
              <img
                src={require("../assets/image/logo/logoMTH.png")}
                alt="FLI Properties"
                className="logo me-2"
                style={{ filter: "none" }}
              />
            </Link>
            {/* <a className="navbar-br/and d-flex align-items-center" href="#">
                    <img src={require('../assets/image/logo/logo.png')} alt="FLI Properties" className="logo me-2" />
                </a> */}
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav ms-auto align-items-lg-center navbar-nav align-items-center d-n">
                <li className="nav-item">
                  <a className="nav-link" href="https://movingtohappy.net/#/app/community-list">
                    Communities
                  </a>
                </li>

                <li className={`nav-item dropdown position-static ${location.pathname === '/' ? 'active' : ''}`}>
                  <a
                    className="nav-link dropdown-toggle fw-semibold"
                    href="#"
                    data-bs-toggle="dropdown"
                  >
                    Homes
                  </a>
                  <div className="dropdown-menu mega-menu w-100 p-4 border-0 shadow" onClick={(e) => e.stopPropagation()}>
                    <div className="container">
                      <div className="row g-4">
                          {searchCity !== "" ?
                            <div className="col-lg-6" id="citycomponentheader">
                              <h5 className="fw-bold mb-3">
                                Home Search in {toUppercase(searchCity)}
                              </h5>

                              <ul className="list-unstyled mb-4">
                                <li>
                                  <a
                                    href={`/neighborhoods/${searchCity.toLowerCase()}`}
                                    className={`text-decoration-none d-block py-1 ${isNeighborhoodPage ? 'active' : ''}`}
                                  >
                                    Neighborhoods
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={`/rentals/${searchCity.toLowerCase()}`}
                                    className={`text-decoration-none d-block py-1 ${isRentalPage ? 'active' : ''}`}
                                  >
                                    Rentals
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={`/builders/${searchCity.toLowerCase()}`}
                                    className={`text-decoration-none d-block py-1 ${isBuilderPage ? 'active' : ''}`}
                                  >
                                    Builders
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={`/search/${searchCity.toLowerCase()}`}
                                    className="text-decoration-none d-block py-1 fw-semibold"
                                  >
                                    See all listings in {searchCity.toLowerCase()}
                                  </a>
                                </li>
                              </ul>

                              <div className="col-md-8" id="megamenucitysearch">
                                <CitySearch
                                  value={searchCity}
                                  onSelect={(selectedCity) => {
                                    const cityLabel = selectedCity?.label || selectedCity || "";
                                    setSearchCity(cityLabel);
                                    localStorage.setItem("searchCity", cityLabel);
                                    // Dispatch event to notify other components
                                    window.dispatchEvent(new CustomEvent("searchCityChanged", { detail: { city: cityLabel } }));
                                  }}
                                  onClear={() => {
                                    setSearchCity("");
                                    localStorage.removeItem("searchCity");
                                    // Dispatch event to notify other components
                                    window.dispatchEvent(new CustomEvent("searchCityChanged", { detail: { city: "" } }));
                                  }}
                                  placeholder="Enter City or ZIP"
                                />
                              </div>
                            </div>
                            :
                            <div className="col-lg-6" id="searchcomponentheader">

                              <h3>
                                Start Your Home Search
                              </h3>
                                           <div className="mt-4 col-md-10">
                                             <SearchFields
                                               onSearch={handleSearchFieldsSubmit}
                                               showMoreOptionsButton={false}
                                               showSearchButton={true}
                                               onMoreOptionsClick={() => setIsVisible(!isVisible)}
                                               isMoreOptionsVisible={isVisible}
                                               initialValues={{
                                                 searchtext: autocompletevalue,
                                                 minprice: selectedMinprice,
                                                 maxprice: selectedMaxprice,
                                                 beds: selectedBeds,
                                                 baths: selectedBaths,
                                               }}
                                             />
                                           </div>
                            </div>
                          }
                        <div className="col-lg-6 text-center">
                          <h5 className="fw-bold mb-3">
                            Search Other Listings
                          </h5>

                          <div className="row">
                            {/* City 1 Section */}
                            <div 
                              className="col-md-6 mb-4" 
                            
                              onClick={() => {
                                if (city1Name) {
                                  navigate(`/search/${city1Name.toLowerCase()}`);
                                  setActiveMega(null);
                                }
                              }}
                            >
                              <div className="row g-2">
                                {loadingCityImages ? (
                                  <>
                                    {/* Top row - 2 loaders */}
                                    <div className="col-6">
                                      <ContentLoader
                                        speed={2}
                                        width="100%"
                                        height={120}
                                        viewBox="0 0 200 120"
                                        backgroundColor="#f3f3f3"
                                        foregroundColor="#ecebeb"
                                      >
                                        <rect x="0" y="0" rx="4" ry="4" width="200" height="120" />
                                      </ContentLoader>
                                    </div>
                                    <div className="col-6">
                                      <ContentLoader
                                        speed={2}
                                        width="100%"
                                        height={120}
                                        viewBox="0 0 200 120"
                                        backgroundColor="#f3f3f3"
                                        foregroundColor="#ecebeb"
                                      >
                                        <rect x="0" y="0" rx="4" ry="4" width="200" height="120" />
                                      </ContentLoader>
                                    </div>
                                    {/* Bottom row - 2 loaders */}
                                    <div className="col-6">
                                      <ContentLoader
                                        speed={2}
                                        width="100%"
                                        height={120}
                                        viewBox="0 0 200 120"
                                        backgroundColor="#f3f3f3"
                                        foregroundColor="#ecebeb"
                                      >
                                        <rect x="0" y="0" rx="4" ry="4" width="200" height="120" />
                                      </ContentLoader>
                                    </div>
                                    <div className="col-6">
                                      <ContentLoader
                                        speed={2}
                                        width="100%"
                                        height={120}
                                        viewBox="0 0 200 120"
                                        backgroundColor="#f3f3f3"
                                        foregroundColor="#ecebeb"
                                      >
                                        <rect x="0" y="0" rx="4" ry="4" width="200" height="120" />
                                      </ContentLoader>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    {/* Top row - 2 images */}
                                    <div className="col-6">
                                      <img
                                        src={city1Images[0] || require("../assets/image/header/mega-menu-img-1.png")}
                                        className="w-100"
                                        alt="FLI Properties"
                                        style={{ 
                                          height: "120px", 
                                          objectFit: "cover",
                                          borderRadius: "4px"
                                        }}
                                      />
                                    </div>
                                    <div className="col-6">
                                      <img
                                        src={city1Images[1] || require("../assets/image/header/mega-menu-img-2.png")}
                                        className="w-100"
                                        alt="FLI Properties"
                                        style={{ 
                                          height: "120px", 
                                          objectFit: "cover",
                                          borderRadius: "4px"
                                        }}
                                      />
                                    </div>
                                    {/* Bottom row - 2 images */}
                                    <div className="col-6">
                                      <img
                                        src={city1Images[2] || require("../assets/image/header/mega-menu-img-3.png")}
                                        className="w-100"
                                        alt="FLI Properties"
                                        style={{ 
                                          height: "120px", 
                                          objectFit: "cover",
                                          borderRadius: "4px"
                                        }}
                                      />
                                    </div>
                                    <div className="col-6">
                                      <img
                                        src={city1Images[3] || require("../assets/image/header/mega-menu-img-4.png")}
                                        className="w-100"
                                        alt="FLI Properties"
                                        style={{ 
                                          height: "120px", 
                                          objectFit: "cover",
                                          borderRadius: "4px"
                                        }}
                                      />
                                    </div>
                                  </>
                                )}
                              </div>
                              {/* City name below images */}
                              <div className="mt-2">
                                {/*<small className="text-muted">GEORGIA</small>*/}
                                <h5 className="fw-bold">{toUppercase(city1Name)}</h5>
                              </div>
                            </div>

                            {/* City 2 Section */}
                            <div 
                              className="col-md-6 mb-4"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                if (city2Name) {
                                  navigate(`/search/${city2Name.toLowerCase()}`);
                                  setActiveMega(null);
                                }
                              }}
                            >
                              <div className="row g-2">
                                {loadingCityImages ? (
                                  <>
                                    {/* Top row - 2 loaders */}
                                    <div className="col-6">
                                      <ContentLoader
                                        speed={2}
                                        width="100%"
                                        height={120}
                                        className="GlobalLoader"
                                        viewBox="0 0 200 120"
                                        backgroundColor="#f3f3f3"
                                        foregroundColor="#ecebeb"
                                      >
                                        <rect x="0" y="0" rx="4" ry="4" width="200" height="120" />
                                      </ContentLoader>
                                    </div>
                                    <div className="col-6">
                                      <ContentLoader
                                        speed={2}
                                        width="100%"
                                        height={120}
                                        viewBox="0 0 200 120"
                                        backgroundColor="#f3f3f3"
                                        foregroundColor="#ecebeb"
                                      >
                                        <rect x="0" y="0" rx="4" ry="4" width="200" height="120" />
                                      </ContentLoader>
                                    </div>
                                    {/* Bottom row - 2 loaders */}
                                    <div className="col-6">
                                      <ContentLoader
                                        speed={2}
                                        width="100%"
                                        height={120}
                                        viewBox="0 0 200 120"
                                        backgroundColor="#f3f3f3"
                                        foregroundColor="#ecebeb"
                                      >
                                        <rect x="0" y="0" rx="4" ry="4" width="200" height="120" />
                                      </ContentLoader>
                                    </div>
                                    <div className="col-6">
                                      <ContentLoader
                                        speed={2}
                                        width="100%"
                                        height={120}
                                        viewBox="0 0 200 120"
                                        backgroundColor="#f3f3f3"
                                        foregroundColor="#ecebeb"
                                      >
                                        <rect x="0" y="0" rx="4" ry="4" width="200" height="120" />
                                      </ContentLoader>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    {/* Top row - 2 images */}
                                    <div className="col-6">
                                      <img
                                        src={city2Images[0] || require("../assets/image/header/mega-menu-img-5.png")}
                                        className="w-100"
                                        alt="FLI Properties"
                                        style={{ 
                                          height: "120px", 
                                          objectFit: "cover",
                                          borderRadius: "4px"
                                        }}
                                      />
                                    </div>
                                    <div className="col-6">
                                      <img
                                        src={city2Images[1] || require("../assets/image/header/mega-menu-img-6.png")}
                                        className="w-100"
                                        alt="FLI Properties"
                                        style={{ 
                                          height: "120px", 
                                          objectFit: "cover",
                                          borderRadius: "4px"
                                        }}
                                      />
                                    </div>
                                    {/* Bottom row - 2 images */}
                                    <div className="col-6">
                                      <img
                                        src={city2Images[2] || require("../assets/image/header/mega-menu-img-7.png")}
                                        className="w-100"
                                        alt="FLI Properties"
                                        style={{ 
                                          height: "120px", 
                                          objectFit: "cover",
                                          borderRadius: "4px"
                                        }}
                                      />
                                    </div>
                                    <div className="col-6">
                                      <img
                                        src={city2Images[3] || require("../assets/image/header/mega-menu-img-8.png")}
                                        className="w-100"
                                        alt="FLI Properties"
                                        style={{ 
                                          height: "120px", 
                                          objectFit: "cover",
                                          borderRadius: "4px"
                                        }}
                                      />
                                    </div>
                                  </>
                                )}
                              </div>
                              {/* City name below images */}
                              <div className="mt-2">
                                {/*<small className="text-muted">GEORGIA</small>*/}
                                <h5 className="fw-bold">{toUppercase(city2Name)}</h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="nav-item">
                  <a className="nav-link" href="https://movingtohappy.net/#/app/find-your-happy">
                    Find Your Happy
                  </a>
                </li>
                <li className={`nav-item ${location.pathname.toLowerCase().includes('/builder') ? 'active' : ''}`}>
                  <a className="nav-link" href="/builders">
                    Build
                  </a>
                </li>
                {/* <li className="nav-item dropdown position-static"><a className="nav-link text-white" href="/neighborhoods">Neighborhoods</a></li>
                <li className="nav-item dropdown position-static"><a className="nav-link text-white" href="/rentals">Rentals</a></li>
                <li className="nav-item dropdown position-static"><a className="nav-link text-white" href="/contact">Contact</a></li> */}
                {isLoggedIn ? (
                  <li className="nav-item ms-3 position-relative">
                    <div className="dropdown user-dropdown">
                      <a
                        href="#"
                        className="user-icon"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i className="fas fa-user-circle"></i>
                      </a>

                      <ul
                        className="dropdown-menu dropdown-menu-start account-menu"
                      >
                        {window.userInfo && (
                          <li>
                            <div className="dropdown-item text-dark fw-semibold">
                              {window.userInfo.FirstName || ""} {window.userInfo.LastName || ""}
                            </div>
                          </li>
                        )}
                        <li>
                          <Link className="dropdown-item" to="/profile">
                            My Account
                          </Link>
                        </li>
                        <li>
                          <Link className="dropdown-item" to="/favorites">
                            Favorites
                          </Link>
                        </li>
                        <li>
                          <a 
                            className="dropdown-item logout text-danger" 
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              handleLogout();
                            }}
                          >
                            Log Out{" "}
                            <i className="fas fa-arrow-right-from-bracket"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                ) : (
                  <>
                    <li className="nav-item">
                      <button
                        className="nav-link text-white btn btn-link p-0 loginBtn"
                        style={{ textDecoration: "none" }}
                        onClick={openLogin}
                      >
                        Login
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className="nav-link text-white btn btn-link p-0"
                        style={{ textDecoration: "none" }}
                        onClick={openSignup}
                      >
                        Join now
                      </button>
                    </li>
                  </>
                )}
              </ul>
              <ul className="navbar-nav align-items-center  d-none d-n">
                {navLinks.map((link, idx) => {
                  // Normalize paths for comparison (remove trailing slashes)
                  const currentPath = location.pathname.replace(/\/$/, '');
                  const linkPath = link.to.replace(/\/$/, '');
                  const isActive = currentPath === linkPath;
                  return (
                  <li
                    key={link.label}
                    className={`nav-item dropdown position-static${isActive ? " active" : ""
                      }`}
                    onMouseEnter={() => link.megaMenu && setActiveMega(idx)}
                    onMouseLeave={() => link.megaMenu && setActiveMega(null)}
                  >
                    {isActive ? (
                      <span 
                        className="nav-link text-white" 
                        style={{ 
                          cursor: 'default',
                          opacity: 0.7
                        }}
                      >
                        {link.label}
                      </span>
                    ) : (
                      <Link 
                        className="nav-link text-white" 
                        to={link.to}
                      >
                        {link.label}
                      </Link>
                    )}

                    {/* 🔥 MEGA MENU */}
                    {link.megaMenu && activeMega === idx && (
                      <div className="dropdown-menu mega-menu w-100 p-4 border-0 shadow show" onClick={(e) => e.stopPropagation()}>
                        <div className="container">
                          <div className="row g-4">
                            {/* LEFT */}
                            <div className="col-lg-6">
                              <h5 className="fw-bold mb-3">
                                Home Search in {toUppercase(searchCity)}
                              </h5>

                              <ul className="list-unstyled mb-4">
                                <li>
                                  <a
                                    href="#"
                                    className={`text-decoration-none d-block py-1 ${isNeighborhoodPage ? 'active' : ''}`}
                                  >
                                    Neighborhoods
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href="#"
                                    className={`text-decoration-none d-block py-1 ${isRentalPage ? 'active' : ''}`}
                                  >
                                    Rentals
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href="#"
                                    className={`text-decoration-none d-block py-1 ${isBuilderPage ? 'active' : ''}`}
                                  >
                                    Builders
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href="#"
                                    className="text-decoration-none d-block py-1 fw-semibold"
                                  >
                                    See all listings in {searchCity}
                                  </a>
                                </li>
                              </ul>

                              <input
                                type="text"
                                className="form-control"
                                defaultValue="LaGrange | GA"
                              />
                            </div>

                            {/* RIGHT */}
                            <div className="col-lg-6 text-center">
                              <h5 className="fw-bold mb-3">
                                Search Other Listings
                              </h5>

                              <div className="row g-3">
                                {megaMenuImages.map((img, i) => (
                                  <div className="col-6 col-md-3" key={i}>
                                    <img
                                      src={img}
                                      className="w-100"
                                      alt="FLI Properties"
                                    />
                                  </div>
                                ))}
                              </div>

                              <div className="row mt-4">
                                <div className="col-md-6">
                                  <small className="text-muted">GEORGIA</small>
                                  <h5 className="fw-bold">Newnan</h5>
                                </div>
                                <div className="col-md-6">
                                  <small className="text-muted">ALABAMA</small>
                                  <h5 className="fw-bold">Auburn</h5>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </nav>

        <Login
          show={showLogin}
          onClose={() => {
            closeModals();
            setIsLoggedIn(!!window.isUserLoggedIn);
          }}
          onSwitchToSignup={openSignup}
        />
        <Signup
          show={showSignup}
          onClose={closeModals}
          onSwitchToLogin={openLogin}
        />

        <div className="custom-header d-block d-md-none">
          <div className="container-fluid px-3 h-100">
            <div className="d-flex align-items-center justify-content-between h-100">
              {isLoggedIn ? (
              <div className="dropdown user-dropdown">
                <a 
                  href="#" 
                  className="user-icon" 
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="fas fa-user-circle"></i>
                </a>

                <ul className="dropdown-menu dropdown-menu-start account-menu">
                  {window.userInfo && (
                    <li>
                      <div className="dropdown-item text-dark fw-semibold">
                        {window.userInfo.FirstName || ""} {window.userInfo.LastName || ""}
                      </div>
                    </li>
                  )}
                  <li>
                    <Link 
                      className="dropdown-item" 
                      to="/profile"
                      onClick={(e) => {
                        // Close dropdown on mobile
                        const dropdown = e.target.closest('.dropdown');
                        if (dropdown) {
                          const bsDropdown = window.bootstrap?.Dropdown?.getInstance(dropdown.querySelector('[data-bs-toggle="dropdown"]'));
                          if (bsDropdown) bsDropdown.hide();
                        }
                      }}
                    >
                      My Account
                    </Link>
                  </li>
                  <li>
                    <Link 
                      className="dropdown-item" 
                      to="/favorites"
                      onClick={(e) => {
                        // Close dropdown on mobile
                        const dropdown = e.target.closest('.dropdown');
                        if (dropdown) {
                          const bsDropdown = window.bootstrap?.Dropdown?.getInstance(dropdown.querySelector('[data-bs-toggle="dropdown"]'));
                          if (bsDropdown) bsDropdown.hide();
                        }
                      }}
                    >
                      Favorites
                    </Link>
                  </li>                
                  <li>
                    <a 
                      className="dropdown-item logout text-danger" 
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleLogout();
                        // Close dropdown on mobile
                        const dropdown = e.target.closest('.dropdown');
                        if (dropdown) {
                          const bsDropdown = window.bootstrap?.Dropdown?.getInstance(dropdown.querySelector('[data-bs-toggle="dropdown"]'));
                          if (bsDropdown) bsDropdown.hide();
                        }
                      }}
                    >
                      Log Out{" "}
                      <i className="fas fa-arrow-right-from-bracket"></i>
                    </a>
                  </li>
                </ul>
              </div>) : (
              <button 
                className="nav-link text-white btn btn-link p-0 loginBtn"
                onClick={openLogin}
              >
                Login
              </button>
              )}
              <div className="logo text-center">
                <Link to="/">
                <img
                  src={require("../assets/image/logo/logoMTH.png")}
                    alt="FLI Properties"
                    className="logo me-2"
                  />
                </Link>
              </div>

              <button
                className="btn p-0 border-0 menu-toggle"
                onClick={() => setMenuOpen(true)}
              >
                <i className="fas fa-bars"></i>
              </button>
            </div>
          </div>
        </div>

        {/* TOP HEADER */}
       {/*} <div className="top-header">
          <div className="top-header-row">
            <div className="row">
              <div className="search-bar col-md-4">
                <input
                  type="text"
                  placeholder="LaGrange | GA"
                  className="w-100 ms-2"
                />
                <div className="closeBtn">
                  <img
                    src={require("../assets/image/web-img/cross-icon-btn.png")}
                    style={{ height: "40px" }}
                    alt="Georgia MLS"
                    id="MLS"
                  />
                </div>
              </div>

              <button
                className="filter-button"
                onClick={() => {
                  console.log("Filter clicked");
                  setFilterOpen(true);
                }}
              >
                <span>3 Filters</span>
                <i className="fa-solid fa-angle-down"></i>
              </button>
            </div>
          </div>

          <div className="sort-homes-row">
            <div className="sort-dropdown">
              SORT:
              <select>
                <option>HIGH - LOW</option>
                <option>LOW - HIGH</option>
              </select>
            </div>
           <div className="homes-count">110 HOMES</div>
          </div>
        </div> */}

        {/* OFFCANVAS MENU */}
        <div
          className={`offcanvas offcanvas-end d-md-none ${menuOpen ? "show" : ""
            }`}
          style={{ visibility: menuOpen ? "visible" : "hidden" }}
        >
          <div className="offcanvas-header">
            <img
              src={require("../assets/image/logo/logoMTH.png")}
              alt="FLI Properties"
              className="logo me-2"
            />
            <button
              className="btn-close"
              onClick={() => setMenuOpen(false)}
            ></button>
          </div>

          <div className="offcanvas-body">
            <ul className="menu-list">
              {["COMMUNITIES", "HOMES", "FIND YOUR HAPPY", "BUILD"].map(
                (item, index) => {
                  // Internal navigation routes
                  const internalRoutes = {
                    "BUILD": "/builders"
                  };
                  
                  // External URLs
                  const externalUrls = {
                    
                    "FIND YOUR HAPPY": "https://movingtohappy.net/#/app/find-your-happy"
                  };
                  
                  const internalRoute = internalRoutes[item];
                  const externalUrl = externalUrls[item];
                  const isInternalLink = !!internalRoute;
                  const isExternalLink = !!externalUrl;
                  
                  return (
                  <li
                    key={index}
                    className={`menu-item ${openMenuIndex === index ? "open" : ""
                      }`}
                  >
                    {isInternalLink ? (
                      <Link
                        to={internalRoute}
                        className="menu-link"
                        onClick={() => setMenuOpen(false)}
                      >
                        {item}
                        <i className="fas fa-chevron-right"></i>
                      </Link>
                    ) : isExternalLink ? (
                      <a
                        href={externalUrl}
                        className="menu-link"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => setMenuOpen(false)}
                      >
                        {item}
                        <i className="fas fa-external-link-alt"></i>
                      </a>
                    ) : (
                      <a
                        href="#"
                        className="menu-link"
                        onClick={(e) => {
                          e.preventDefault();
                          setOpenMenuIndex(openMenuIndex === index ? null : index);
                        }}
                      >
                        {item}
                        <i className="fas fa-chevron-down"></i>
                      </a>
                    )}
                    {/*- Dropdown content for HOMES (index 1) -*/}
                    {!isInternalLink && !isExternalLink && item === "HOMES" && openMenuIndex === index && (
                      <div className="dropdown-content sub-menu">
                        {/* Show search mode when city is selected */}
                        {searchCity ? (
                          <div className="search-mode">
                            <p className="small text-muted mb-2">Home Search In {toTitleCase(searchCity)}</p>

                            <div className="fw-semibold mb-3">
                              <div 
                                style={{ cursor: "pointer" }}
                                className={isNeighborhoodPage ? 'active' : ''}
                                onClick={() => {
                                  navigate(`/neighborhoods/${searchCity.toLowerCase()}`);
                                  setMenuOpen(false);
                                }}
                              >
                                NEIGHBORHOODS
                              </div>
                              <div 
                                style={{ cursor: "pointer" }}
                                className={isRentalPage ? 'active' : ''}
                                onClick={() => {
                                  navigate(`/rentals/${searchCity.toLowerCase()}`);
                                  setMenuOpen(false);
                                }}
                              >
                                RENTALS
                              </div>
                              <div 
                                style={{ cursor: "pointer" }}
                                className={isBuilderPage ? 'active' : ''}
                                onClick={() => {
                                  navigate(`/builders/${searchCity.toLowerCase()}`);
                                  setMenuOpen(false);
                                }}
                              >
                                BUILDERS
                              </div>
                              <div
                                style={{ cursor: "pointer" }}
                                className=""
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (searchCity && searchCity.trim() !== "") {
                                    const targetPath = `/search/${searchCity.toLowerCase().trim()}`;
                                    const currentPath = location.pathname.toLowerCase();
                                    // If already on the same route, force navigation by navigating away first
                                    if (currentPath === targetPath.toLowerCase()) {
                                      // Temporarily navigate to a different route, then back to force re-render
                                      navigate("/search", { replace: true });
                                      setTimeout(() => {
                                        navigate(targetPath);
                                      }, 10);
                                    } else {
                                      navigate(targetPath);
                                    }
                                    setMenuOpen(false);
                                  } else {
                                    navigate("/search");
                                    setMenuOpen(false);
                                  }
                                }}
                              >
                                SEE ALL LISTINGS IN {searchCity ? searchCity.toUpperCase() : "ALL CITIES"}
                              </div>
                            </div>

                            <div className="search-chip mb-3">
                              <span>{toTitleCase(searchCity)}</span>
                               <div className="closeBtn">
          <img
            src={require("../assets/image/web-img/cross-icon-btn.png")}
            style={{ height: "40px", cursor: "pointer" }}
            alt="Clear"
          onClick={() => {
                                  setSearchCity("");
                                  localStorage.removeItem("searchCity");
                                }}
          />
        </div>
                              
                            </div>
                          </div>
                        ) : (
                          <div className="default-search">
                            <p className="small text-muted mb-2">Start Your Home Search</p>
                            <CitySearch
                                    value={searchCity}
                                    onSelect={(selectedCity) => {
                                      try {
                                        const cityLabel = selectedCity?.label || selectedCity || "";
                                        if (cityLabel && cityLabel.trim() !== "") {
                                          setSearchCity(cityLabel);
                                          localStorage.setItem("searchCity", cityLabel);
                                          // Dispatch event to notify other components
                                          window.dispatchEvent(new CustomEvent("searchCityChanged", { detail: { city: cityLabel } }));
                                          const cityPath = cityLabel.toLowerCase().trim();
                                          if (navigate) {
                                            navigate(`/search/${cityPath}`);
                                          } else {
                                            console.error("navigate function is not available");
                                          }
                                        }
                                      } catch (error) {
                                        console.error("Error in CitySearch onSelect:", error);
                                      }
                                    }}
                                    onClear={() => {
                                      setSearchCity("");
                                      localStorage.removeItem("searchCity");
                                      // Dispatch event to notify other components
                                      window.dispatchEvent(new CustomEvent("searchCityChanged", { detail: { city: "" } }));
                                    }}
                                    placeholder="Enter City or ZIP"
                                  />
                                  <br />
                           {/* <button 
                              className="btn w-100 mt-3 search-btn"
                              onClick={() => {
                                const searchFieldsData = {
                                  searchtext: searchCity ? (typeof searchCity === 'string' ? searchCity : searchCity.label || searchCity) : null,
                                  minprice: null,
                                  maxprice: null,
                                  beds: null,
                                  baths: null,
                                };
                                handleSearchFieldsSubmit(searchFieldsData);
                                setMenuOpen(false);
                              }}
                            >
                              SEARCH HOMES
                            </button>
                            */}
                          </div>
                        )}

                        <div className="home-results mt-4">
                          <p className="small text-muted mb-2">Search Other Listings</p>
                          {city1Name && (
                            <div 
                              className="listing-item"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                navigate(`/search/${city1Name.toLowerCase()}`);
                                setMenuOpen(false);
                              }}
                            >
                              <img
                                src={city1Images[0] || require("../assets/image//header/mega-menu-img-1.png")}
                                style={{ height: "45px", width: "60px", borderRadius: "6px", objectFit: "cover" }}
                                alt={city1Name}
                              />
                              <div>
                                {/*<small className="text-muted d-block" style={{ fontSize: "13px" }}>GEORGIA</small>*/}
                                <span style={{ fontSize: "18px", fontWeight: "500" }}>{city1Name}</span>
                              </div>
                            </div>
                          )}
                          {city2Name && (
                            <div 
                              className="listing-item"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                navigate(`/search/${city2Name.toLowerCase()}`);
                                setMenuOpen(false);
                              }}
                            >
                              <img
                                src={city2Images[0] || require("../assets/image//header/mega-menu-img-2.png")}
                                style={{ height: "45px", width: "60px", borderRadius: "6px", objectFit: "cover" }}
                                alt={city2Name}
                              />
                              <div>
                                {/*<small className="text-muted d-block" style={{ fontSize: "13px" }}>ALABAMA</small>*/}
                                <span style={{ fontSize: "18px", fontWeight: "500" }}>{city2Name}</span>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                    
                    {/*- Dropdown content for COMMUNITIES (index 0) -*/}
                    {!isInternalLink && !isExternalLink && item === "COMMUNITIES" && openMenuIndex === index && (
                      <>
                     
                          <div className="dropdown-content sub-menu">
                            {/*<div className="text-muted mb-2">Discover Communities</div>
                            <p className="small text-muted">
                              Sign in to see your personalized community matches.
                            </p>*/}
                            <div className="match-item" onClick={() => window.location.href = "https://movingtohappy.net/#/app/community-details/c96cb2cc-898f-4321-826b-0f7ce5793a11"}>
                              <div><span className="d-block">GEORGIA</span>Atlanta</div>
                            </div>

                            <div className="match-item" onClick={() => window.location.href = "https://movingtohappy.net/#/app/community-details/52fe9a57-7164-4fca-8d86-7b2569beca05"}>
                              <div><span className="d-block">GEORGIA</span>LaGrange</div>
                            </div>

                            <div className="match-item" onClick={() => window.location.href = "https://movingtohappy.net/#/app/community-details/97810d56-83f5-4d28-b736-a90f25acbf1d"}>
                              <div><span className="d-block">ALABAMA</span>Trussville</div>
                            </div>
                            <a 
                              href="https://movingtohappy.net/#/app/home-page" 
                              rel="noopener noreferrer"
                              className="btn btn-primary w-100 mt-3"
                            >
                             TAKE THE QUIZ
                            </a>                            
                          </div>
                      </>
                    )}

                  </li>
                  );
                })}
            </ul>
            
            {/* Action Buttons */}
            {isLoggedIn ? (
              <div className="mobile-menu-actions">             
              <button
                className="btn w-100"
                onClick={() => {
                  navigate("/contact");
                  setMenuOpen(false);
                }}
              >
                CONTACT US
              </button>
            </div>
            ):(
            <div className="mobile-menu-actions">
              <button
                className="btn w-100"
                onClick={() => {
                  openSignup();
                  setMenuOpen(false);
                }}
              >
                JOIN NOW
              </button>
              <button
                className="btn w-100"
                onClick={() => {
                  navigate("/contact");
                  setMenuOpen(false);
                }}
              >
                CONTACT US
              </button>
            </div>
            )}
          </div>
        </div>

       {/* FILTER MODAL Removed */}
      </header>
    </>
  );
};

export default Header;

// When user logs in (in Login.js), also set localStorage.setItem('userInfo', JSON.stringify(userInfo));
